import { Button, makeStyles, Box } from "@material-ui/core";
import { Alert, Card, DatePicker, Divider, InputNumber } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SummaryModal from "./summaryModal";
import config from "../../config";
import { BsChevronDown } from "react-icons/bs";
import Expenses from "./expense";
import ExpensesModal from "../expenses-management/add-edit-expense";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import CustomTabs from "../tabs";
import CustomTable from "../table";
import Loader from "../loader";
import { useCounterId } from "../../provider/counterProvider";
import { useAccess } from "../../provider/AccessProvider";
import { COUNTERACCESS } from "../../utils/constant";
import dayjs from "dayjs";

const useStyles = makeStyles((theme) => ({
  root: {
    "& p": {
      margin: "0",
    },
    "& h4": {
      margin: "0",
    },
  },
  tabs: {
    "& .ant-tabs-nav": {
      background: "#FDFBE8",
      "& .ant-tabs-tab-active": {
        background: "#fff",
      },
    },
    "& .ant-tabs-tab": {
      padding: "16px 36px",
      margin: "0",
    },
  },
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
  },
  contentListStyle: {
    "&::-webkit-scrollbar": {
      width: "2px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "body::-webkit-scrollbar-thumb": {
      borderRadius: "20px",
    },
  },
}));

const CashManagement = () => {
  const classes = useStyles();
  const [tabKey, setTabKey] = useState("1");
  const currentDate = moment().format("MMM DD, YYYY");
  const [isStarted, setIsStarted] = useState(false);
  const [counterSales, setCounterSales] = useState({
    totalCashSale: 0,
    totalCashReceived: 0,
    cashBalancePaid: 0,
    totalCardSale: 0,
    totalUpiSale: 0,
    totalCreditSale: 0,
    totalSales: 0,
    totalExpenses: 0,
  });
  const access = useAccess(COUNTERACCESS);
  const [open, setOpen] = useState(false);
  const [isLoading, setLoading] = useState();
  const [expenseLoading, setExpenseLoading] = useState(true);
  const [openBalance, setOpenBalance] = useState("");
  const [counterId, setCounterId] = useCounterId("");
  const [bills, setBills] = useState([]);
  const [filterBills, setFilterBills] = useState([]);
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const employeeId = useSelector((state) => state.shopDetails.empId);
  const [employeeList, setEmployeeList] = useState([]);
  const [expenseList, setExpenseList] = useState([]);
  const [openExpense, setOpenExpense] = useState(false);
  const expenseTypeList = useSelector(
    (state) => state.shopDetails.expensesType
  );
  const [customDate, setCustomDate] = useState([]);
  const currencyFormatter = useCurrency();
  const country = useCountry();
  const [startEndDate, setStateEndDate] = useState({
    startDate: "",
    endDate: "",
  });

  useEffect(() => {
    const fetchCounterHistory = async () => {
      try {
        var res = await fetch(`${config.newApiGateway}/counter/counter`, {
          method: "post",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-type": "application/json",
          },
          body: JSON.stringify({
            employeeId: employeeId ? employeeId : "",
            shopId: shopId,
            type: "fetchHistory",
          }),
        });
        res = await res.json();
        console.log("REs", res);
        if (res.code === "ERROR") {
          return alert(res.message);
        }
        setBills(res.data);
        const result = res.data.sort((a, b) => {
          return (
            moment(b.billingDate, "YYYY-MM-DD").format("X") -
            moment(a.billingDate, "YYYY-MM-DD").format("X")
          );
        });
        console.log("result", result);
        setFilterBills(result);
      } catch (err) {
        console.log("ERR", err);
      }
    };
    const fetchEmployee = async () => {
      try {
        var res = await fetch(
          `${config.newApiGateway}/employe/createEmployee-fetchEmployee`,
          {
            method: "post",
            body: JSON.stringify({
              shopId: shopId,
              action: "fetchEmployee",
            }),
            headers: {
              "x-api-key": `${config.newApiKey}`,
              "Content-Type": "application/json",
            },
          }
        );
        res = await res.json();
        if (res.code === "SUCCESS") {
          setLoading(false);
          setEmployeeList(res.data);
        } else {
          setLoading(false);
          alert(res.message);
        }
      } catch (err) {
        console.log("err", err);
      }
    };
    if (tabKey === "3") {
      fetchCounterHistory();
    }
    if (shopId) {
      fetchEmployee();
    }
  }, [tabKey, shopId, employeeId]);

  const handleEndClick = () => {
    setOpen(true);
  };

  const handleClick = async () => {
    if (openBalance === "") {
      return alert("Please enter opening balance");
    }

    try {
      var res = await fetch(`${config.newApiGateway}/counter/counter`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          openBalance: openBalance,
          employeeId: employeeId ? employeeId : "",
          shopId: shopId,
          type: "start",
          counterOpenedTime: new Date().toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
          }),
        }),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        console.log("REs", res);
        return alert(res.message);
      }
      if (res.code === "SUCCESS") {
        setCounterId(res.data.counterId);
        setCounterSales((prev) => ({
          ...prev,
          totalSales: prev.totalSales + openBalance,
        }));
      }
      console.log("REs success", res);
      setIsStarted(true);
    } catch (err) {
      console.log("ERR", err);
    }
  };

  // const getTotalAmountReceivedByPaymentType = (bills) => {
  //   const totalByPaymentType = {};
  //   bills.forEach((bill) => {
  //     if (totalByPaymentType[bill.otherDetails.paymentMethod]) {
  //       totalByPaymentType[bill.otherDetails.paymentMethod] += parseFloat(
  //         bill.amountPaid
  //       );
  //     } else {
  //       totalByPaymentType[bill.otherDetails.paymentMethod] = parseFloat(
  //         bill.amountPaid
  //       );
  //     }
  //   });
  //   return totalByPaymentType;
  // };

  // const getTotalBalance = (bills) => {
  //   let result = 0;
  //   bills.forEach((bill) => {
  //     result += parseFloat(bill.balanceAmount);
  //   });
  //   return result;
  // };

  const getCounterOpeningDetails = async () => {
    try {
      var res = await fetch(`${config.newApiGateway}/counter/counter`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          shopId,
          employeeId: employeeId ? employeeId : "",
          type: "fetch",
        }),
      });
      res = await res.json();
      return res;
    } catch (err) {
      console.log("Err", err);
      return {};
    }
  };

  const handleDateRange = (v) => {
    if (v === null) {
      setFilterBills(bills);
      setCustomDate([]);
    } else {
      const startDate = dayjs(v[0]).format("YYYY-MM-DD");
      const endDate = dayjs(v[1]).format("YYYY-MM-DD");
      setFilterBills((prev) =>
        prev.filter(
          (item) => item.billingDate >= startDate && item.billingDate <= endDate
        )
      );
      setCustomDate(v);
    }
  };

  const fetchExpenses = async (counterId) => {
    try {
      let res = await fetch(`${config.newApiGateway}/counter/counter`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          type: "fetchCounterExpencess",
          shopId: shopId,
          from: moment().format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
          counterId: counterId,
          employeeId: employeeId ? employeeId : "",
        }),
      });
      res = await res.json();
      console.log("response", res);
      if (res.code === "SUCCESS") {
        const expenseAmount = res.data.reduce((acc, cur) => {
          return acc + parseFloat(cur.expenseAmount);
        }, 0);
        const result = res.data.map((i) => {
          const type = expenseTypeList.find(
            (item) => item.expensesTypeId === i.expenseType
          );
          return {
            ...i,
            expenseTypeName: type ? type.expensesTypeName : "",
          };
        });
        setExpenseList(result);
        // setExpensesList(res.data);
        setCounterSales((prev) => ({
          ...prev,
          totalExpenses: expenseAmount,
        }));
      }
    } catch (err) {
      console.error("Error", err);
    } finally {
      setExpenseLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async (shopId) => {
      let res = await getCounterOpeningDetails(shopId);
      fetchExpenses(res.counterId);
      if (res.code === "SUCCESS") {
        if (res.counterAnalytics)
          setCounterSales((prev) => ({
            ...prev,
            totalCashReceived: res.counterAnalytics.totalCashReceived,
            totalCashSale: res.counterAnalytics.totalCashSale,
            cashBalancePaid: res.counterAnalytics.cashBalancePaid,
            totalCardSale: res.counterAnalytics.totalCardSale,
            totalUpiSale: res.counterAnalytics.totalUpiSale,
            totalCreditSale: res.counterAnalytics.totalCreditSale,
            totalSales: res.counterAnalytics.totalSales,
            openTime: `${currentDate} ${res.data.counterOpenedTime}`,
          }));
        if (Object.keys(res.data).length > 0) {
          setOpenBalance(res.data.counterOpeningBalance);
          setCounterId(res.data.billId);
          setIsStarted(true);
        }
      }
      setLoading(false);
    };
    setLoading(true);
    if (shopId) {
      fetchData(shopId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId, currentDate]);

  const endCounter = async (
    v1,
    v2,
    v3,
    v4,
    v5,
    v6,
    v7,
    v8,
    v9,
    v10,
    v11,
    v12,
    v13
  ) => {
    if (!v2) return alert("Please enter amount of cash handed over to owner.");
    const payload = {
      shopId,
      counterId,
      type: "closeCounter",
      availableCash: v1,
      cashHandover: v2,
      closingBalance: v10 - v11,
      totalCashReceived: v4,
      cashBalancePaid: v5,
      totalCashSale: v6,
      counterCloseTime: new Date().toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
      }),
      upiSales: v7,
      creditSales: v8,
      cardSales: v9,
      totalSales: v10 - v11,
      totalExpenses: v11,
      expenses: v12,
      notes: v13.data,
    };
    console.log("payload", payload);
    try {
      var res = await fetch(`${config.newApiGateway}/counter/counter`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      res = await res.json();
      if (res.code === "SUCCESS") {
        setOpen(false);
        setIsStarted(false);
        setCounterSales({
          totalCashSale: 0,
          totalCashReceived: 0,
          cashBalancePaid: 0,
          totalCardSale: 0,
          totalUpiSale: 0,
          totalCreditSale: 0,
          totalSales: 0,
          totalExpenses: 0,
        });
        setCounterId("");
        setExpenseList([]);
        setOpenBalance("");
        return;
      }
      alert(res.message);
    } catch (err) {
      console.log("Err", err);
      alert("Error while closing counter.");
    }
  };

  const tabs = [
    {
      key: "1",
      label: "Today",
    },
    {
      key: "2",
      label: "Expenses",
    },
    {
      key: "3",
      label: "History",
    },
  ];

  const historyColumns = [
    {
      title: "DATE",
      render: (data) => {
        return <span>{moment(data.billingDate).format("DD-MM-YYYY")}</span>;
      },
      sorter: (a, b) =>
        moment(b.billingDate, "YYYY-MM-DD").format("X") -
        moment(a.billingDate, "YYYY-MM-DD").format("X"),
    },
    {
      title: "BILLED BY",
      render: (rowData) => {
        if (rowData.employeeId) {
          const employee = employeeList.find(
            (i) => i.userId === rowData.employeeId
          );
          return <div>{employee ? employee.userName : "Employee Deleted"}</div>;
        } else {
          return <div>You</div>;
        }
      },
    },
    {
      title: "START TIME",
      dataIndex: "counterOpenedTime",
      defaultSort: "desc",
    },
    {
      title: "END TIME",
      dataIndex: "counterClosedTime",
    },
    {
      title: "OPENING BALANCE",
      defaultSort: "desc",
      sorter: (a, b) =>
        parseInt(b.counterOpeningBalance) - parseInt(a.counterOpeningBalance),
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.counterOpeningBalance)}</div>;
      },
    },
    {
      title: "TOTAL CASH SALES",
      sorter: (a, b) => parseInt(b.totalCashSale) - parseInt(a.totalCashSale),
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.totalCashSale)}</div>;
      },
    },
    {
      title: "TOTAL UPI SALES",
      sorter: (a, b) => parseInt(b.totalUpiSale) - parseInt(a.totalUpiSale),
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.totalUpiSale)}</div>;
      },
    },
    {
      title: "TOTAL CREDIT SALES",
      sorter: (a, b) =>
        parseInt(b.totalCreditSale) - parseInt(a.totalCreditSale),
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.totalCreditSale)}</div>;
      },
    },
    {
      title: "TOTAL CARD SALES",
      sorter: (a, b) => parseInt(b.totalCardSale) - parseInt(a.totalCardSale),
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.totalCardSale)}</div>;
      },
    },
    {
      title: "TOTAL EXPENSE",
      sorter: (a, b) => parseInt(b.totalExpenses) - parseInt(a.totalExpenses),
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.totalExpenses)}</div>;
      },
    },
    {
      title: "CASH HANDOVER",
      sorter: (a, b) => parseInt(b.cashHandover) - parseInt(a.cashHandover),
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.cashHandover)}</div>;
      },
    },
    {
      title: "TOTAL SALES",
      sorter: (a, b) => parseInt(b.totalSales) - parseInt(a.totalSales),
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.totalSales)}</div>;
      },
    },
  ];

  const exportHead = [
    "DATE",
    "BILLED BY",
    "START TIME",
    "END TIME",
    "OPENING BALANCE",
    "TOTAL CASH SALES",
    "TOTAL UPI SALES",
    "TOTAL CREDIT SALES",
    "TOTAL CARD SALES",
    "TOTAL EXPENSE",
    "CASH HANDOVER",
    "TOTAL SALES",
  ];

  const exportValue = [
    "billingDate",
    {
      field: "employeeName",
      render: (rowData) => {
        if (rowData.employeeId) {
          const employee = employeeList.find(
            (i) => i.userId === rowData.employeeId
          );
          return employee ? employee.userName : "Employee Deleted";
        } else {
          return "You";
        }
      },
    },
    "counterOpenedTime",
    "counterClosedTime",
    "counterOpeningBalance",
    "totalCashSale",
    "totalUpiSale",
    "totalCreditSale",
    "totalCardSale",
    "totalExpenses",
    "cashHandover",
    "totalSales",
  ];

  if (!access.counter(false)) {
    return (
      <Alert
        style={{ marginTop: "20px", padding: "20px" }}
        message="You don't have access, Please contact your administrator to request the appropriate access."
        type="error"
      />
    );
  }
  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };
  return (
    <>
      <div>
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <Loader size={56} />
          </Box>
        ) : (
          <>
            <CustomTabs
              activeKey={tabKey}
              items={tabs}
              style={{
                marginBottom: "20px",
              }}
              onTabChange={(v) => setTabKey(v)}
            />

            {tabKey === "1" && (
              <Card>
                <h6>{currentDate}</h6>
                {!isStarted && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <h6>Opening Cash Balance</h6>
                      <InputNumber
                        style={{
                          width: 200,
                        }}
                        type="number"
                        size="large"
                        prefix={country.CurrencySymbol}
                        value={openBalance}
                        onChange={(v) => {
                          setOpenBalance(v);
                        }}
                      />
                    </div>

                    <Button
                      style={{
                        width: "100%",
                        color: "#EF4667",
                        border: "1px solid #EF4667",
                        marginTop: "2rem",
                      }}
                      variant="outlined"
                      onClick={handleClick}
                    >
                      START COUNTER
                    </Button>
                  </>
                )}

                {isStarted && (
                  <Button
                    style={{
                      width: "100%",
                      color: "#fff",
                      border: "1px solid #EF4667",
                      marginTop: "2rem",
                      background: "#E60F00",
                    }}
                    onClick={handleEndClick}
                  >
                    END COUNTER
                  </Button>
                )}
                {isStarted && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        aligmItems: "center",
                        justifyContent: "space-between",
                        marginTop: "2rem",
                      }}
                    >
                      <div>Start of Counter</div>
                      <div>{counterSales.openTime}</div>
                    </div>
                    <Divider className={classes.dividerStyle} />
                    <div
                      style={{
                        display: "flex",
                        aligmItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>Opening Cash Balance</div>
                      <div>{currencyFormatter(openBalance)}</div>
                    </div>
                    <Divider className={classes.dividerStyle} />
                    <div
                      style={{
                        display: "flex",
                        aligmItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>Total Upi Sales</div>
                      <div>{currencyFormatter(counterSales.totalUpiSale)}</div>
                    </div>
                    <Divider className={classes.dividerStyle} />
                    <div
                      style={{
                        display: "flex",
                        aligmItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>Total Card Sales</div>
                      <div>{currencyFormatter(counterSales.totalCardSale)}</div>
                    </div>
                    <Divider className={classes.dividerStyle} />
                    <div
                      style={{
                        display: "flex",
                        aligmItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>Total Credit Sales</div>
                      <div>
                        {currencyFormatter(counterSales.totalCreditSale)}
                      </div>
                    </div>
                    <Divider className={classes.dividerStyle} />
                    <div
                      style={{
                        display: "flex",
                        aligmItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>Total Cash Sales</div>
                      <div>{currencyFormatter(counterSales.totalCashSale)}</div>
                    </div>
                    <Divider className={classes.dividerStyle} />
                    <div
                      style={{
                        display: "flex",
                        aligmItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>Total Expenses</div>
                      <div>
                        -{currencyFormatter(counterSales.totalExpenses)}
                      </div>
                    </div>
                    <Divider className={classes.dividerStyle} />
                    <div
                      style={{
                        display: "flex",
                        aligmItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <h4
                        style={{
                          fontWeight: "700",
                          color: "green",
                        }}
                      >
                        Total Sales
                      </h4>
                      <h4
                        style={
                          counterSales.totalSales - counterSales.totalExpenses <
                          0
                            ? {
                                fontWeight: "700",
                                color: "rgb(230, 15, 0)",
                              }
                            : {
                                fontWeight: "700",
                                color: "green",
                              }
                        }
                      >
                        {currencyFormatter(
                          counterSales.totalSales - counterSales.totalExpenses
                        )}
                      </h4>
                    </div>
                    {/* <div
                style={{
                  display: "flex",
                  aligmItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>Cash Expense</div>
                <div>0.00</div>
              </div> */}
                  </>
                )}
              </Card>
            )}

            {tabKey === "2" && (
              <>
                {!access.counterExpenses(false) ? (
                  <Alert
                    message="You don't have access, Please contact your administrator to request the appropriate access."
                    type="error"
                  />
                ) : (
                  <Expenses
                    loading={expenseLoading}
                    setOpen={(prev) => setOpenExpense(prev || true)}
                    expensesList={expenseList}
                    counterId={counterId}
                  />
                )}
              </>
            )}

            {tabKey === "3" && (
              <>
                {!access.counterHistory(false) ? (
                  <Alert
                    message="You don't have access, Please contact your administrator to request the appropriate access."
                    type="error"
                    style={{
                      padding: "20px",
                      textAlign: "center",
                    }}
                  />
                ) : (
                  <>
                    <Card
                      bodyStyle={{
                        padding: 20,
                      }}
                      style={{
                        marginBottom: 20,
                      }}
                    >
                      <DatePicker.RangePicker
                        value={customDate}
                        onChange={handleDateRange}
                        disabledDate={disabledDate}
                        allowClear={true}
                      />
                    </Card>
                    <CustomTable
                      columns={historyColumns}
                      data={filterBills}
                      title={"History"}
                      excelExport={true}
                      exportHead={exportHead}
                      csvAccessKey="historyCSVExport"
                      exportValue={exportValue}
                    />
                  </>
                )}
              </>
            )}

            {/* <Tabs
              style={{
                margin: "1rem",
                background: "#fff",
                minHeight: "calc(100vh - 100px)",
              }}
              activeKey={tabKey}
              onChange={handleTabs}
              className={classes.tabs}
            >
              <TabPane tab="Today" key={"1"}>
                <div
                  style={{
                    maxWidth: "80%",
                    margin: "0 auto",
                  }}
                >
                  <h6>{currentDate}</h6>
                  {!isStarted && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <h6>Opening Cash Balance</h6>
                        <OutlinedInput
                          startAdornment={
                            <InputAdornment position="start">
                              {country.CurrencySymbol}
                            </InputAdornment>
                          }
                          type="number"
                          value={openBalance}
                          onChange={(e) => setOpenBalance(e.target.value)}
                        />
                      </div>

                      <Button
                        style={{
                          width: "100%",
                          color: "#EF4667",
                          border: "1px solid #EF4667",
                          marginTop: "2rem",
                        }}
                        variant="outlined"
                        onClick={handleClick}
                      >
                        START COUNTER
                      </Button>
                    </>
                  )}

                  {isStarted && (
                    <Button
                      style={{
                        width: "100%",
                        color: "#fff",
                        border: "1px solid #EF4667",
                        marginTop: "2rem",
                        background: "#E60F00",
                      }}
                      onClick={handleEndClick}
                    >
                      END COUNTER
                    </Button>
                  )}
                  {isStarted && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          aligmItems: "center",
                          justifyContent: "space-between",
                          marginTop: "2rem",
                        }}
                      >
                        <div>Start of Counter</div>
                        <div>{counterSales.openTime}</div>
                      </div>
                      <Divider className={classes.dividerStyle} />
                      <div
                        style={{
                          display: "flex",
                          aligmItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>Opening Cash Balance</div>
                        <div>{currencyFormatter(openBalance)}</div>
                      </div>
                      <Divider className={classes.dividerStyle} />
                      <div
                        style={{
                          display: "flex",
                          aligmItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>Total Upi Sales</div>
                        <div>
                          {currencyFormatter(counterSales.totalUpiSale)}
                        </div>
                      </div>
                      <Divider className={classes.dividerStyle} />
                      <div
                        style={{
                          display: "flex",
                          aligmItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>Total Card Sales</div>
                        <div>
                          {currencyFormatter(counterSales.totalCardSale)}
                        </div>
                      </div>
                      <Divider className={classes.dividerStyle} />
                      <div
                        style={{
                          display: "flex",
                          aligmItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>Total Credit Sales</div>
                        <div>
                          {currencyFormatter(counterSales.totalCreditSale)}
                        </div>
                      </div>
                      <Divider className={classes.dividerStyle} />
                      <div
                        style={{
                          display: "flex",
                          aligmItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>Total Cash Sales</div>
                        <div>
                          {currencyFormatter(
                            counterSales.totalCashSale -
                              (counterSales.totalExpenses || 0)
                          )}
                        </div>
                      </div>
                      <Divider className={classes.dividerStyle} />
                      <div
                        style={{
                          display: "flex",
                          aligmItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>Total Expenses</div>
                        <div>
                          {currencyFormatter(counterSales.totalExpenses)}
                        </div>
                      </div>
                      <Divider className={classes.dividerStyle} />
                      <div
                        style={{
                          display: "flex",
                          aligmItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <h4
                          style={{
                            fontWeight: "700",
                            color: "green",
                          }}
                        >
                          Total Sales
                        </h4>
                        <h4
                          style={
                            counterSales.totalSales -
                              counterSales.totalExpenses <
                            0
                              ? {
                                  fontWeight: "700",
                                  color: "rgb(230, 15, 0)",
                                }
                              : {
                                  fontWeight: "700",
                                  color: "green",
                                }
                          }
                        >
                          {currencyFormatter(
                            counterSales.totalSales - counterSales.totalExpenses
                          )}
                        </h4>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          aligmItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>Cash Expense</div>
                        <div>0.00</div>
                      </div>
                    </>
                  )}
                </div>
              </TabPane>
              <TabPane tab="Expenses" key={"2"}>
                <Expenses
                  loading={expenseLoading}
                  setOpen={(prev) => setOpenExpense(prev || true)}
                  expensesList={expenseList}
                  counterId={counterId}
                />
              </TabPane>
              <TabPane tab="History" key="3">
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    padding: "0 1rem",
                  }}
                >
                  <DatePicker
                    value={startEndDate.startDate}
                    suffixIcon={<BsChevronDown />}
                    placeholder="Start date"
                    onChange={(v) =>
                      setStateEndDate((prev) => ({ ...prev, startDate: v }))
                    }
                  />
                  <DatePicker
                    value={startEndDate.endDate}
                    placeholder="End date"
                    suffixIcon={<BsChevronDown />}
                    onChange={(v) =>
                      setStateEndDate((prev) => ({ ...prev, endDate: v }))
                    }
                  />
                </div>

                <MaterialTable
                  data={filterBills}
                  style={{
                    boxShadow: "none",
                  }}
                  columns={[
                    {
                      title: "DATE",
                      field: "billingDate",
                      defaultSort: "desc",
                    },
                    {
                      title: "BILLED BY",
                      render: (rowData) => {
                        if (rowData.employeeId) {
                          const employee = employeeList.find(
                            (i) => i.userId === rowData.employeeId
                          );
                          return (
                            <div>
                              {employee
                                ? employee.userName
                                : "Employee Deleted"}
                            </div>
                          );
                        } else {
                          return <div>You</div>;
                        }
                      },
                    },
                    {
                      title: "START TIME",
                      field: "counterOpenedTime",
                      defaultSort: "desc",
                    },
                    {
                      title: "END TIME",
                      field: "counterClosedTime",
                    },
                    {
                      title: "OPENING BALANCE",
                      field: "counterOpeningBalance",
                      defaultSort: "desc",
                      render: (rowData) => {
                        return (
                          <div>
                            {currencyFormatter(rowData.counterOpeningBalance)}
                          </div>
                        );
                      },
                    },
                    {
                      title: "TOTAL CASH SALES",
                      field: "totalCashSale",
                      render: (rowData) => {
                        return (
                          <div>{currencyFormatter(rowData.totalCashSale)}</div>
                        );
                      },
                    },
                    {
                      title: "TOTAL UPI SALES",
                      field: "totalUpiSale",
                      render: (rowData) => {
                        return (
                          <div>{currencyFormatter(rowData.totalUpiSale)}</div>
                        );
                      },
                    },
                    {
                      title: "TOTAL CREDIT SALES",
                      field: "totalCreditSale",
                      render: (rowData) => {
                        return (
                          <div>
                            {currencyFormatter(rowData.totalCreditSale)}
                          </div>
                        );
                      },
                    },
                    {
                      title: "TOTAL CARD SALES",
                      field: "totalCardSale",
                      render: (rowData) => {
                        return (
                          <div>{currencyFormatter(rowData.totalCardSale)}</div>
                        );
                      },
                    },
                    {
                      title: "TOTAL EXPENSE",
                      render: (rowData) => {
                        return (
                          <div>{currencyFormatter(rowData.totalExpenses)}</div>
                        );
                      },
                    },
                    {
                      title: "TOTAL SALES",
                      field: "totalSales",
                      render: (rowData) => {
                        return (
                          <div>{currencyFormatter(rowData.totalSales)}</div>
                        );
                      },
                    },
                    // {
                    //   title: "Actions",
                    //   render: (data) => {
                    //     return (
                    //       <div
                    //         style={{
                    //           display: "flex",
                    //           alignItems: "center",
                    //           justifyContent: "center",
                    //           gap: "16px",
                    //         }}
                    //       >
                    //         <Button>View</Button> <Button>Download</Button>{" "}
                    //       </div>
                    //     );
                    //   },
                    // },
                  ]}
                  title={<></>}
                  icons={tableIcons}
                  isLoading={isLoading}
                  options={{
                    pageSize: 10,
                    emptyRowsWhenPaging: true,
                    pageSizeOptions: [10, 20, 50, 100, 500],
                  }}
                  components={{
                    Pagination: PatchedPagination,
                  }}
                />
              </TabPane>
            </Tabs> */}
          </>
        )}
      </div>
      <SummaryModal
        open={open}
        setOpen={setOpen}
        counterSales={{ ...counterSales, openBalance }}
        endCounter={endCounter}
        setCounterSales={setCounterSales}
      />
      <ExpensesModal
        open={openExpense}
        setOpen={() => setOpenExpense(false)}
        fetchExpenses={fetchExpenses}
        dateField={false}
        counterId={counterId}
      />
    </>
  );
};

export default CashManagement;
